(() => {
  'use strict';
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const mounted = new WeakSet();
  function mount(scope = document) {
    const root = scope.matches?.('[data-kinora-about]') ? scope : scope.querySelector('[data-kinora-about]');
    if (!root || mounted.has(root)) return;
    mounted.add(root);
    if (reduced.matches || !('IntersectionObserver' in window)) return;
    const targets = [...root.querySelectorAll('[data-about-reveal]')];
    const show = target => target.classList.remove('is-about-pending');
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        show(entry.target);
        observer.unobserve(entry.target);
      });
    }, { threshold: .06 });
    targets.forEach(target => {
      if (target.getBoundingClientRect().top <= innerHeight) return;
      target.classList.add('is-about-pending');
      observer.observe(target);
    });
    const revealAll = () => { observer.disconnect(); targets.forEach(show); };
    reduced.addEventListener('change', event => { if (event.matches) revealAll(); }, { once: true });
    document.addEventListener('shopify:section:unload', event => { if (event.target.contains(root)) revealAll(); }, { once: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(), { once: true });
  else mount();
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();
